import DirectDebitPadHeader from './direct-debit-pad-header';

export default DirectDebitPadHeader;
